export const DEBUG_EVENTS = 'DEBUG_EVENTS';
export const GET_DEBUG_EVENTS = 'GET/DEBUG_EVENTS';
export const GET_DEBUG_EVENTS_SUCCESS = 'GET/DEBUG_EVENTS/SUCCESS';
export const GET_DEBUG_EVENTS_FAILED = 'GET/DEBUG_EVENTS/FAILED';
